<div class="pb">

  <% if ( !enabled ) { %>
  <p class="pb-notice">
    <i class="icon icon--info"></i>
    <span><%= _lcs( 'Web Push ist in dieser Umgebung nicht aktiv (services.webPush in der core-api-Konfiguration). Nachrichten werden nicht zugestellt.' ) %></span>
  </p>
  <% } %>

  <!-- ============ Reach ============ -->
  <section class="pb-kpis">
    <div class="kpi">
      <div class="kpi__top">
        <span class="kpi__label"><%= _lcs( 'Geräte mit Benachrichtigungen' ) %></span>
        <span class="kpi__icon"><i class="icon icon--smartphone"></i></span>
      </div>
      <div class="kpi__value"><%= devices %></div>
    </div>
    <div class="kpi">
      <div class="kpi__top">
        <span class="kpi__label"><%= _lcs( 'Davon mit Gäste-Konto' ) %></span>
        <span class="kpi__icon kpi__icon--sand"><i class="icon icon--user-round"></i></span>
      </div>
      <div class="kpi__value"><%= users %></div>
    </div>
    <div class="kpi">
      <div class="kpi__top">
        <span class="kpi__label"><%= _lcs( 'Unterkünfte mit Geräten' ) %></span>
        <span class="kpi__icon kpi__icon--sky"><i class="icon icon--building-2"></i></span>
      </div>
      <div class="kpi__value"><%= housesWithDevices %> <small><%= _lcs( 'von {count}', { count : houses.length } ) %></small></div>
    </div>
  </section>

  <div class="pb__split">

    <!-- ============ Compose ============ -->
    <form class="widget pb-compose" data-id="pb-form" novalidate>
      <div class="widget__head">
        <h3 class="widget__title"><i class="icon icon--bell-ring"></i> <%= _lcs( 'Nachricht an die Gäste' ) %></h3>
      </div>
      <div class="widget__body pb-compose__body">

        <div class="field">
          <label class="field__label" for="pb-title"><%= _lcs( 'Titel' ) %></label>
          <div class="field__control">
            <input class="field__input" id="pb-title" name="title" type="text" maxlength="<%= limits.title %>"
                   placeholder="<%= _lcs( 'z. B. Neu in deiner Gäste-App: der Aufenthaltsplaner' ) %>" required />
          </div>
          <p class="field__note"><span><span data-id="pb-count-title">0</span> / <%= limits.title %></span></p>
        </div>

        <div class="field">
          <label class="field__label" for="pb-body"><%= _lcs( 'Nachricht' ) %></label>
          <div class="field__control field__control--textarea">
            <textarea class="field__input" id="pb-body" name="body" rows="4" maxlength="<%= limits.body %>" required></textarea>
          </div>
          <p class="field__note"><span><span data-id="pb-count-body">0</span> / <%= limits.body %> · <%= _lcs( 'Die Nachricht kommt im Namen des jeweiligen Hauses an — schreib sie so, dass sie zu jedem Haus passt.' ) %></span></p>
        </div>

        <div class="field">
          <label class="field__label" for="pb-url"><%= _lcs( 'Beim Antippen öffnen' ) %></label>
          <div class="field__control">
            <select class="field__input field__select" id="pb-url" name="url">
              <% targets.forEach( function( t ) { %>
              <option value="<%= t.url %>"><%= t.label %></option>
              <% } ); %>
            </select>
          </div>
        </div>

        <!-- Which houses -->
        <fieldset class="pb-audience">
          <legend class="field__label"><%= _lcs( 'Unterkünfte' ) %></legend>
          <label class="pb-radio">
            <input type="radio" name="audience" value="all" checked />
            <span><%= _lcs( 'Alle Unterkünfte' ) %> <small>(<%= _lcs( '{count} Geräte', { count : devices } ) %>)</small></span>
          </label>
          <label class="pb-radio">
            <input type="radio" name="audience" value="some" />
            <span><%= _lcs( 'Ausgewählte Unterkünfte' ) %></span>
          </label>

          <div class="pb-houses" data-id="pb-houses" hidden>
            <div class="pb-houses__tools">
              <div class="field__control pb-houses__search">
                <span class="field__icon"><i class="icon icon--building-2"></i></span>
                <input class="field__input" type="search" data-id="pb-search" placeholder="<%= _lcs( 'Unterkunft suchen …' ) %>" />
              </div>
              <button class="btn btn--ghost btn--sm" type="button" data-id="pb-pick-reachable"><%= _lcs( 'Alle mit Geräten' ) %></button>
              <button class="btn btn--ghost btn--sm" type="button" data-id="pb-pick-none"><%= _lcs( 'Keine' ) %></button>
            </div>
            <ul class="pb-houses__list">
              <% houses.forEach( function( h ) { %>
              <li class="pb-houses__item" data-name="<%= ( h.name + ' ' + h.slug ).toLowerCase() %>">
                <label>
                  <input type="checkbox" name="house" value="<%= h.id %>" data-devices="<%= h.devices %>" />
                  <span class="pb-houses__name"><%= h.name %> <small><%= h.slug %></small></span>
                  <span class="pill <%= h.devices ? 'pill--ok' : 'pill--neutral' %>"><%= _lcs( '{count} Geräte', { count : h.devices } ) %></span>
                </label>
              </li>
              <% } ); %>
            </ul>
            <p class="field__note" data-id="pb-picked"></p>
          </div>
        </fieldset>

        <!-- Preview -->
        <div class="pb-preview" aria-hidden="true">
          <span class="pb-preview__label"><%= _lcs( 'Vorschau' ) %></span>
          <div class="pb-preview__card">
            <span class="pb-preview__icon"><i class="icon icon--bell"></i></span>
            <div class="pb-preview__text">
              <span class="pb-preview__app"><%= _lcs( 'Name der Unterkunft' ) %> · <%= _lcs( 'jetzt' ) %></span>
              <strong class="pb-preview__title" data-id="pb-preview-title"><%= _lcs( 'Titel der Nachricht' ) %></strong>
              <span class="pb-preview__body" data-id="pb-preview-body"><%= _lcs( 'Hier steht dein Text.' ) %></span>
            </div>
          </div>
        </div>

        <p class="pb-error" data-id="pb-error" role="alert" hidden></p>

        <div class="pb-compose__actions">
          <span class="pb-compose__reach" data-id="pb-reach"></span>
          <button class="btn btn--primary btn--sm" type="submit" data-id="pb-send">
            <i class="icon icon--send-horizontal"></i> <%= _lcs( 'Senden' ) %>
          </button>
        </div>
      </div>
    </form>

    <!-- ============ History ============ -->
    <section class="widget pb-history">
      <div class="widget__head">
        <h3 class="widget__title"><i class="icon icon--clock"></i> <%= _lcs( 'Verlauf' ) %></h3>
      </div>
      <div class="widget__body widget__body--flush">
        <% if ( !messages.length ) { %>
        <p class="pb-history__empty"><%= _lcs( 'Noch keine Plattform-Nachricht gesendet. Nachrichten, die Gastgeber selbst an ihr Haus schicken, stehen hier nicht.' ) %></p>
        <% } else { %>
        <ul class="pb-history__list">
          <% messages.forEach( function( m ) { %>
          <li class="pb-history__item">
            <div class="pb-history__top">
              <strong class="pb-history__title"><%= m.title %></strong>
              <span class="pb-history__date"><%= m.date %></span>
            </div>
            <p class="pb-history__body"><%= m.body %></p>
            <div class="pb-history__meta">
              <span class="pill pill--region"><%= m.audienceLabel %></span>
              <span><i class="icon icon--check"></i> <%= _lcs( '{count} zugestellt', { count : m.sent } ) %></span>
              <% if ( m.failed ) { %><span class="pb-history__warn"><i class="icon icon--triangle-alert"></i> <%= _lcs( '{count} fehlgeschlagen', { count : m.failed } ) %></span><% } %>
              <% if ( m.removed ) { %><span><i class="icon icon--trash-2"></i> <%= _lcs( '{count} abgemeldet', { count : m.removed } ) %></span><% } %>
            </div>
          </li>
          <% } ); %>
        </ul>
        <% } %>
      </div>
    </section>

  </div>
</div>
